(() => {
  const request = (url, { method = 'GET', body = null, headers = {} } = {}) =>
    new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(method, url);
      Object.entries(headers).forEach(([key, value]) => xhr.setRequestHeader(key, value));
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.responseText);
          return;
        }
        reject(new Error(xhr.responseText || xhr.statusText));
      };
      xhr.onerror = () => reject(new Error(xhr.statusText || 'Network request failed'));
      xhr.send(body);
    });

  const addUpsellItem = async (form, event) => {
    if (!form || !form.closest('.seapuri-cart-upsell-card')) return;

    event?.preventDefault?.();
    event?.stopImmediatePropagation?.();

    if (form.dataset.seapuriUpsellSubmitting === 'true') return;

    const submitButton = form.querySelector('[type="submit"]');
    if (!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

    form.dataset.seapuriUpsellSubmitting = 'true';
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const formData = new FormData(form);
    const variantId = formData.get('id') || form.querySelector('[name="id"]')?.value;

    if (variantId && !formData.get('id')) formData.set('id', variantId);

    if (cart?.getSectionsToRender) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement?.(document.activeElement);
    }

    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');
    form.querySelector('.loading__spinner')?.classList.remove('hidden');

    try {
      const cartAddUrl = typeof routes !== 'undefined' ? routes.cart_add_url : '/cart/add.js';
      const responseText = await request(cartAddUrl, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      const parsedState = JSON.parse(responseText);

      if (parsedState.status) {
        throw new Error(parsedState.description || parsedState.message || 'Unable to add item to cart');
      }

      if (cart?.renderContents && parsedState.sections) {
        cart.renderContents(parsedState);
      } else {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-upsell',
          productVariantId: formData.get('id'),
          cartData: parsedState
        });
      }
    } catch (error) {
      console.error(error);
      submitButton.removeAttribute('aria-disabled');
    } finally {
      delete form.dataset.seapuriUpsellSubmitting;
      submitButton.classList.remove('loading');
      form.querySelector('.loading__spinner')?.classList.add('hidden');
    }
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target?.closest?.('form');
      if (form?.closest?.('.seapuri-cart-upsell-card')) addUpsellItem(form, event);
    },
    true
  );

  window.SeapuriCartUpsellSubmit = (event, trigger) => {
    const form = trigger?.closest?.('form') || event?.target?.closest?.('form');
    addUpsellItem(form, event);
  };

  if (!window.customElements || customElements.get('upsell-slider')) return;

  customElements.define(
    'upsell-slider',
    class UpsellSlider extends HTMLElement {
      constructor() {
        super();
        this.swiperInstance = null;
      }

      connectedCallback() {
        this.initSwiper();
        window.setTimeout(() => this.initSwiper(), 120);
        document.addEventListener('cart:updated', () => this.initSwiper());
      }

      initSwiper() {
        const swiperEl = this.querySelector('.swiperupsell');
        if (!swiperEl || typeof Swiper === 'undefined') return;

        if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);

        this.swiperInstance = new Swiper(swiperEl, {
          speed: 600,
          grabCursor: true,
          freeMode: {
            enabled: true,
            momentumRatio: 0.7
          },
          spaceBetween: 12,
          breakpoints: {
            0: { slidesPerView: 2.08, spaceBetween: 10 },
            768: { slidesPerView: 2.45, spaceBetween: 12 },
            992: { slidesPerView: 3.08, spaceBetween: 14 }
          }
        });
      }
    }
  );
})();
